import { Alert, AlertTitle } from '@mui/material';

export default function AlertValidationPending() {
  return (
    <Alert severity="info">
      <AlertTitle>Pending</AlertTitle>
      Your data is not saved or validated.
    </Alert>
  );
}
